import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules from './modules'
import Loading from 'components/Loading'
import { getVerifyToken, login } from 'store/siteConfig'

export default function(route) {
  const Login = Loadable({
    loader: () => import('./Login'),
    render(loaded, props) {
      const Component = connect((state) => ({
        oauthLoginState: state.oauthLoginState,
        siteConfig: state.siteConfig
      }), {
        login,
        getVerifyToken
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/login`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Login {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
